import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
const store = new Vuex.Store({
  state: {
    user: {},
    authGroup: [],
    model: [],
    category: null,
    modelV3Cate: [],
    // 页面初始化
    pageInit: false,
    pageFrom: '',
    limitInfo: null
  },
  mutations: {
    setUser(state, user) {
      state.user = user
    },
    setCategory(state, cate) {
      state.category = cate
    },
    // v3模型分类
    setModelV3Cate(state, list) {
      state.modelV3Cate = list
    },
    setAuthGroup(state, authGroup) {
      state.authGroup = authGroup
    },
    clearAuthGroup(state) {
      state.authGroup = []
    },
    clearUser(state) {
      state.user = {}
    },
    setModel(state, { id, blob }) {
      state.model[id] = blob
    },
    setPageInit(state, status) {
      state.pageInit = status
    },
    setPageFrom(state, page) {
      state.pageFrom = page
    },
    setLimitInfo(state, info) {
      state.limitInfo = info || {}
    }
  },
  actions: {
    actionSetUser(context, user = {}) {
      return context.commit('setUser', user)
    },
    actionSetAuthGroup(context, authGroup = {}) {
      return context.commit('setAuthGroup', authGroup)
    },
    actionClearAuthGroup(context) {
      return context.commit('clearAuthGroup')
    },
    actionClearUser(context) {
      return context.commit('clearUser')
    },
    actionSetModel(context, { id, blob }) {
      context.commit('setModel', { id, blob })
    }
  },
  getters: {
    getterUser(state) {
      return state.user
    },
    getterAuthGroup(state) {
      return state.authGroup
    }
  }
})

export default store
